import { useMutation, useQueryClient } from '@tanstack/react-query'
import { addUserToOrganization as addUserToOrganizationApi } from '../services/apiUsers.ts'
import { toast } from '../utils/sweetAlert.ts'

export function useAddUserToOrg() {
  const queryClient = useQueryClient()
  // console.log(firstName, lastName, email, role, 'insideEdit')

  const { isLoading: isEditing, mutate: addUserToOrg } = useMutation({
    mutationFn: addUserToOrganizationApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      toast('success', 'Your changes have been successfully saved!')
    },
    onError: (error: any) => {
      toast('error', `Something went wrong! ${error.message}`)
    },
  })

  return { isEditing, addUserToOrg }
}
